export enum UserResourceType {
  file = 'file',
  solidWorksCAMPluginBundle = 'SolidWorks Cam Plugin Bundle',
}

export enum FileResourceIsConveratble {
  convertable = 'convertable',
  notConvertable = 'notConvertable',
}
